// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

import { constants } from '../../modules';

// Use named rather than default exports.
const MemberStatus = dynamic(() => import('./MemberStatus').then(mod => mod.MemberStatus));
const MemberStatusV3 = dynamic(() => import('./MemberStatusV3/MemberStatusV3').then(mod => mod.MemberStatusV3));

export const MemberStatusConfig = {
  emptyLabel: 'memberStatus',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/memberStatus`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MemberStatusEditable = (props: any) => {
  return props.cqPath.includes('datapagecomponent') ? (
    props?.model?.variation?.toUpperCase() === constants.VARIATION_3 ? (
      <MemberStatusV3 {...props} />
    ) : (
      <MemberStatus {...props} />
    )
  ) : (
    <EditableComponent config={MemberStatusConfig} {...props}>
      {props?.model?.variation?.toUpperCase() === constants.VARIATION_3 ? (
        <MemberStatusV3 {...props} />
      ) : (
        <MemberStatus {...props} />
      )}
    </EditableComponent>
  );
};
